"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuthStore, type User } from "@/stores/auth";

export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isLoading = useAuthStore((s) => s.isLoading);
  const login = useAuthStore((s) => s.login);
  const register = useAuthStore((s) => s.register);
  const logout = useAuthStore((s) => s.logout);

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    register,
    logout,
  };
}

export function useRequireAuth(): {
  user: User;
  isAuthenticated: true;
  isLoading: boolean;
  logout: () => void;
} {
  const router = useRouter();
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isLoading = useAuthStore((s) => s.isLoading);
  const logout = useAuthStore((s) => s.logout);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      router.push("/login");
    }
  }, [isAuthenticated, isLoading, router]);

  // Return the user as non-null (callers should guard with isLoading check)
  return {
    user: user as User,
    isAuthenticated: true,
    isLoading,
    logout,
  };
}
